import { type ReactElement } from 'react'
import { ButtonAdd, LinkList, NotReady, Page } from '@components'
import { useExternalLinks, useTranslation } from '@front/model'
import { Link, createFileRoute } from '@tanstack/react-router'
import { isEmpty, isNotEmpty } from '@terros/common'

function LinksRoute(): ReactElement {
  const { data, isLoading, error, refetch, isFetching } = useExternalLinks({ fetchAll: true })
  const { t } = useTranslation()
  if (isLoading || error || !data) return <NotReady data={data} error={error} id='links' isLoading={isLoading} />

  return (
    <Page>
      <Page.Heading title={t('Links')} refetch={refetch} isFetching={isFetching}>
        <ButtonAdd component={Link} to='add' />
      </Page.Heading>
      <Page.Content scrollArea>
        {isEmpty(data) && <Page.Hero icon='link' title={t('No Links')} />}
        {isNotEmpty(data) && <LinkList data={data} />}
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/settings/links/')({
  component: LinksRoute,
})
